import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { rules as extRules } from './ValidateForm';
import { getLocale } from '@utils';

const rules = {
  ...extRules,
  isName: (str) => /^[\ .a-zA-Z\u4e00-\u9fa5]+$/.test(str),
  isUsername: (str) => /^[a-zA-Z0-9]{4,12}$/.test(str),
}

const messages = require('../../../resources/messages.json');

/**
 * this is the copy for `ValidateForm` but support real-time vlidate
 */
export default class ValidateFormItem extends Component {

  static propTypes = {
    autoValidate: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errors: {}
    };
    /*
     errors: {
     username: [] // error codes
     }
     */
  }

  /**
   * validate the element and show the errors
   * @param children
   * @param callback
   * @returns {{hasError: boolean, errors: {}}}
   */
  validate(children = this.props.children, callback) {
    let self = this;
    let hasError = false;
    let errors = {};
    let customizeRules = this.props.customizeRules;
    React.Children.forEach(children, (child) => {
      // the child must be form element
      if (child.type !== 'input' && child.type !== 'select') {
        return
      }

      let childKeys = _.keys(self.props);
      let value = child.props.value;
      let errorCodes = [];
      _.each(childKeys, ((key) => {
        // rules matched
        if (rules[key] && !rules[key](value) && (value || key === 'isRequired')) {
          hasError = true;
          errorCodes.push(key)
        }
      }));
      //customize rules
      if(value && customizeRules && customizeRules.length > 0) {
        _.each(customizeRules, (customizeRule) => {
          if(customizeRule.rule(value)) {
            hasError = true;
            errorCodes.push(customizeRule.name)
          }
        })
      }
      if (errorCodes.length > 0) {
        errors[child.props.name] = errorCodes
      }
    });
    this.setState({
      hasError: hasError,
      errors: errors
    });
    if ( callback ) {
      callback({
        hasError: hasError,
        errors: errors
      })
    } else {
      return {
        hasError,
        errors,
      };
    }
  }

  /**
   * check if the current element has validation error
   * @param children
   * @returns {boolean}
   */
  hasError(children = this.props.children) {
    let self = this;
    let hasError = false;
    let customizeRules = this.props.customizeRules;
    React.Children.forEach(children, (child) => {
      // the child must be form element
      if (child.type !== 'input' && child.type !== 'select') {
        return
      }

      let childKeys = _.keys(self.props);
      let value = child.props.value;
      _.each(childKeys, ((key) => {
        // rules matched
        if (rules[key] && !rules[key](value) && (value || key === 'isRequired')) {
          hasError = true;
        }
      }));

      //customize rules
      if(value && customizeRules && customizeRules.length > 0) {
        _.each(customizeRules, (customizeRule) => {
          if(customizeRule.rule(value)) {
            hasError = true;
          }
        })
      }
    });
    return hasError
  }

  render() {
    const { errors } = this.state;
    let customizeRules = this.props.customizeRules;
    if(customizeRules && customizeRules.length > 0) {
      _.each(customizeRules, (customizeRule) => {
        messages['form'][customizeRule.name] = customizeRule.message
      })
    }
    const wrappedChildren = React.Children.map(this.props.children, (child) => {
      if (child.type === 'input') {
        if (errors[child.props.name]) {
          return (
            <div className={'error'}>
              { child }
              { child.props.placeholder && <label>{child.props.placeholder}</label> }
              <div className="message">{messages['form'][errors[child.props.name][0]][getLocale()]}</div>
            </div>
          );
        } else {
          return (
            <div className={'ok'}>
              { child }
              { child.props.placeholder && <label>{child.props.placeholder}</label> }
            </div>
          );
        }
      }
      if (child.type === 'select') {
        if (errors[child.props.name]) {
          return (
            <div className={'error'}>
              { child.props.placeholder && <label>{child.props.placeholder}</label> }
              <div className="select">
                { child }
              </div>
              <div className="message">{messages['form'][errors[child.props.name][0]][getLocale()]}</div>
            </div>
          );
        } else {
          return (
            <div className={'ok'}>
              { child.props.placeholder && <label>{child.props.placeholder}</label> }
              <div className="select">
                { child }
              </div>
            </div>
          );
        }
      }
      return child
    });
    return (
      <div className="field floating">
        { wrappedChildren }
      </div>
    )
  }
}
